import { render, staticRenderFns } from "./AllowPermissions.vue?vue&type=template&id=68883c90&scoped=true&"
import script from "./AllowPermissions.vue?vue&type=script&lang=js&"
export * from "./AllowPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68883c90",
  null
  
)

export default component.exports